import ComplaintView from "../../../../components/consultation/complaintView";

const ComplaintActionDrawer = ({
    complaintData,
    consultation,
    messageData,
    raisedByProfileUrl,
    againstByProfileUrl,
    againstByWarningCount,
    consultationBooleans,
    onClose,
    onSendMessage,
    onMessageClose,
    onMessageChange,
    onMessageTabChange,
    onMessageCheck,
    onSubmitMessage,
    onRefund,
    isRefundDisabled,
    showWhatsapp = false
}) => {
    return (
        <ComplaintView
            consultation={consultation}
            consultationBooleans={consultationBooleans}
            handlComplaintsDetailClose={onClose}
            handleSendMessage={onSendMessage}
            handleSendMessageClose={onMessageClose}
            complaintIdData={{ data: complaintData, rasiedByProfile: raisedByProfileUrl, againstByProfile: againstByProfileUrl, againstByWarningCount: againstByWarningCount }}
            handleMessageChange={onMessageChange}
            handleMessageTabChange={onMessageTabChange}
            messageData={messageData}
            handleMessageCheck={onMessageCheck}
            handleSubmitMessage={onSubmitMessage}
            onRefund={onRefund}
            isRefundDisabled={isRefundDisabled}
            showWhatsapp={showWhatsapp}
        />
    );
};

export default ComplaintActionDrawer;
